import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { eq } from 'ember-truth-helpers';

interface GeneralButtonsChoiceSegmentButtonSignature {
  Args: {
    className?: string;
    icon?: IconName;
    isChecked: boolean;
    isDisabled?: boolean;
    label: string;
    onClick: () => void;
    subLabel?: string;
    subLabel2?: string;
    type: 'radio' | 'checkbox';
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLabelElement;
}

export default class GeneralButtonsChoiceSegmentButton extends Component<GeneralButtonsChoiceSegmentButtonSignature> {
  @action onClick(): void {
    if (this.args.isDisabled) {
      return;
    }

    this.args.onClick();
  }

  <template>
    <label
      class="button-bordered text-300--medium flex flex-col gap-400 overflow-hidden
        {{if @isChecked 'button-bordered--checked'}}
        {{if @isDisabled 'button-bordered--disabled'}}"
      {{on "mouseup" this.onClick}}
      {{! tabindex makes the label element focusable }}
      tabindex="0"
      ...attributes
    >
      {{yield}}

      <div class="mt-auto flex w-full items-center justify-between gap-300">
        {{#if @icon}}
          <PrismIcon @color="inherit" @name={{@icon}} @size="small" />
        {{/if}}
        <div class="flex flex-col items-start truncate">
          <span class="button-bordered__text truncate" title={{@label}}>
            {{@label}}
          </span>
          {{#if @subLabel}}
            <span class="truncate" title={{@subLabel}}>{{@subLabel}}</span>
          {{/if}}
          {{#if @subLabel2}}
            <span>{{@subLabel2}}</span>
          {{/if}}
        </div>
        <input checked={{@isChecked}} type={{@type}} />
        <span class="button-bordered__select {{@type}}">
          {{#if @isChecked}}
            {{#if (eq @type "radio")}}
              <span class="circle"></span>
            {{else if (eq @type "checkbox")}}
              <PrismIcon @color="inherit" @name="checkmark" @size="small" />
            {{/if}}
          {{/if}}
        </span>
      </div>
    </label>
  </template>
}
